import React, { useState } from "react";
import { TableUi } from "../../ui/TableUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { ZoomInOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { detalleComprobanteMovimientoSetActive } from "../../../actions/inventario";
import { DetalleLoteSeriePreviewModal } from "./modal/DetalleLoteSeriePreviewModal";
import { CantidadColumn, RemoveDetailBtn } from "../../ui";
import { Form } from "antd";

const columns_table = (props) => {
  const { handleDelete, handlePreview } = props;
  return [
    {
      title: "#",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Item",
      dataIndex: "item_nombre",
      key: "item_nombre",
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      key: "cantidad",
      align: "right",
      render: (text, record, index) => (
        <>
          <CantidadColumn
            cantidad={text}
            unidadmedida_nombre={record?.unidadmedida_nombre}
          />
        </>
      ),
    },
    {
      title: "Detalle",
      dataIndex: "detalle",
      key: "detalle",
      align: "center",
      render: (text, record, index) => (
        <>
          {record?.manejalotes && (
            <ButtonUi
              typeUi={TipoButtonConstants.CustomButton}
              text="Lotes"
              icon={<ZoomInOutlined />}
              onClick={() => handlePreview(record)}
            />
          )}
          {record?.manejaseries && (
            <ButtonUi
              typeUi={TipoButtonConstants.CustomButton}
              text="Series"
              icon={<ZoomInOutlined />}
              onClick={() => handlePreview(record)}
            />
          )}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record, index) => (
        <RemoveDetailBtn
          size="small"
          onClick={() => handleDelete(record?.id)}
        />
      ),
    },
  ];
};

export const MovimientoTrasladoFormTable = ({
  detallecomprobantemovimiento,
  title,
}) => {
  const [openPreview, setOpenPreview] = useState(false);
  const form = Form.useFormInstance();
  const dispatch = useDispatch();
  const hideModalPreview = () => setOpenPreview(false);
  const handlePreview = (record) => {
    dispatch(detalleComprobanteMovimientoSetActive(record));
    setOpenPreview(true);
  };
  const handleDelete = (key) =>
    form.setFieldValue(
      "detallescomprobantemovimiento",
      detallecomprobantemovimiento?.filter((item) => item.id !== key),
    );

  return (
    <>
      <TableUi
        columns={columns_table({ handleDelete, handlePreview })}
        rowKey="id"
        size="small"
        data={detallecomprobantemovimiento}
        title={title}
      />
      <DetalleLoteSeriePreviewModal
        open={openPreview}
        onCancelModal={hideModalPreview}
      />
    </>
  );
};
